module.exports = __webpack_public_path__ + "img/icon-commitment-06.96c49191.svg";